export default "__VITE_ASSET__67SJVtMK__"